import React, { useState, useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import ReactCodeMirror, { EditorView } from '@uiw/react-codemirror';
import { html } from '@codemirror/lang-html';
import { githubLight } from '@uiw/codemirror-theme-github';
import { encode } from 'js-base64';
import DOMPurify from 'dompurify';
const { sanitize } = DOMPurify;

export const CodeEditor = ({ initialValue, shouldSanitize, formElementName, onChange }) => {
  const [editorValue, setEditorValue] = useState(initialValue);
  const [sanitizedValue, setSanitizedValue] = useState('');
  const isInitialMount = useRef(true);

  const sanitizeHTML = value => {
    return encode(
      sanitize(value, {
        ADD_TAGS: ['iframe', '#comment'],
        FORCE_BODY: true,
        ADD_ATTR: ['target', 'allow', 'allowfullscreen', 'frameborder', 'scrolling'],
      })
    );
  };

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      setSanitizedValue(initialValue);
      if (onChange) onChange(initialValue);
    } else if (shouldSanitize) {
      const newSanitizedValue = sanitizeHTML(editorValue);
      setSanitizedValue(newSanitizedValue);
      if (onChange) onChange(newSanitizedValue);
    } else {
      setSanitizedValue(editorValue);
      if (onChange) onChange(editorValue);
    }
  }, [editorValue, shouldSanitize, onChange, initialValue]);

  const valueChanged = useCallback(val => {
    setEditorValue(val);
  }, []);

  return (
    <>
      <ReactCodeMirror
        value={editorValue}
        theme={githubLight}
        height="250px"
        extensions={[html(), EditorView.lineWrapping]}
        onChange={valueChanged}
      />
      <input name={formElementName} value={sanitizedValue} type="hidden" className="hidden" />
    </>
  );
};

CodeEditor.propTypes = {
  initialValue: PropTypes.string,
  shouldSanitize: PropTypes.bool,
  formElementName: PropTypes.string,
  onChange: PropTypes.func,
};
